module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d4c76faf58b94e84464a1d4de6702387.png";